import * as svg from "../../../assets/info-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const InfoIcon = iconBuilder(svg, "InfoIcon", "0 0 16 16");
